import validateVar from "./validation/validateVariable";
import {emptyValue} from "./global";

function hasInvoiceAddress(invoice_address) {
    return validateVar(invoice_address) && invoice_address !== emptyValue;
}

export default hasInvoiceAddress;